import Hero from '../Components/Hero/hero'
import Categories from '../Components/home/categories'
import AboutUs from '../Components/home/aboutUs'
import LearningStreams from '../Components/home/LearningStreams'
import Testimonials from '../Components/home/employeeDetails'
import Banner from '../Components/home/registrationCard'
 

const Home = () => {
  return (
    <div>
        
    <Hero/>
    <Categories/>
    <AboutUs/>
    <LearningStreams/>
    <Testimonials/>
    <Banner/>

 
      
    </div>
  )
}

export default Home
